// @flow
import React from 'react'
import Path from 'routes/path'
import { accountSignUpUrl } from 'frontend_core/dist/helpers/url'

type PropTypes = {
  currentUser: Object,
}

export default (props: PropTypes) => {
  const currentUser = props.currentUser
  if (currentUser) {
    return (
      <div className="page__stripes top-page__padding">
        <div className="container">
          <div className="top-more__area top-flow__regist">
            <div className="top-bonus__points">
              <p className="top-bonus__points-inner">
                {i18n.t('referral.campaign')}
              </p>
            </div>
            <h2 className="top-flow__referral-title">
              {i18n.t('referral.title')}
              <br />
              <span>{i18n.t('referral.subTitle')}</span>
            </h2>
            <a
              href={Path.referrals()}
              className="button-blue top-flow__regist-button"
            >
              {i18n.t('referral.button')}
            </a>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="stripe-regist">
        <div className="top-more__area stripe-regist__container">
          <div className="stripe-regist__unit">
            <p className="stripe-regist__title-guide">
              {i18n.t('regist.titleGuide')}
            </p>
            <div className="stripe-regist__present">
              <p className="stripe-regist__everyone">
                <span>{i18n.t('regist.everyone')}</span>
              </p>
              <h2 className="stripe-regist__title">
                <span className="stripe-regist__title-large">
                  <span className="stripe-regist__title-medium">¥</span>
                  {i18n.t('regist.price')}
                </span>
                <span className="stripe-regist__title-small">
                  {i18n.t('regist.title')}
                  <br />
                </span>
              </h2>
            </div>
          </div>
          <div className="stripe-regist__text">{i18n.t('regist.text')}</div>
          <div className="stripe-regist__button_wrap">
            <a
              href={accountSignUpUrl()}
              className="btn__large btn__style bg_blue"
            >
              {i18n.t('regist.button')}
            </a>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/RegistAccount/index.jsx